import React from "react";
import { Link } from "react-router-dom";

function BillingSuccess() {
    return (
        <div className="page">
            <div className="card">
                <h1>Payment successful</h1>
                <p>Your subscription is active. It may take a moment to update.</p>
                <Link to="/profile">Return to profile</Link>
            </div>
        </div>
    );
}

export default BillingSuccess;
